// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prefooter a[data-v-12f60882]{display:block;font-size:12px}@media(max-width:767px){.prefooter a[data-v-12f60882]{padding:8px 0}}.prefooter img[data-v-12f60882]{display:inline-block;max-width:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
